
export function rolesToMenu (roles) {

	let menuAll = [
		{
			id: 1,
			title: '首页',
			icon: '',
			level:1,
			path: '/',
			p_id: 0,
			order_num: 1,
			role: 'all',
			children: [

			]
		},
		{
			id: 13,
			title: '一门受理协同办理',
			icon: '业务办理',
			level: 1,
			path: '',
			p_id: 0,
			order_num: 0,
			role: '一门受理',
			children: [

			]
		},
		{
			id: 131,
			title: '受理',
			icon: '业务办理',
			level: 2,
			path: '/one_acceptance_list',
			p_id:13,
			order_num: 0,
			role: '一门受理',

		},
		// {
		// 	id: 132,
		// 	title: '办理',
		// 	icon: '业务办理',
		// 	level: 2,
		// 	path: '/one_acceptance_transact_list',
		// 	p_id:13,
		// 	order_num: 1,
		// 	role: '一门受理',
		// 	children: [

		// 	]
		// },
		{
			id: 2,
			title: '基础信息',
			icon: '基础信息',
			level: 1,
			path: '',
			p_id: 0,
			order_num: 2,
			role: '系统管理员,协理员,区县审批,数据修正,查询统计,救助标准管理',
			children: [

			]
		},
		{
			id: 21,
			title: '救助标准管理',
			icon: '救助标准管理',
			level: 2,
			path: '/treatment_standard',
			p_id: 2,
			order_num: 6,
			role: '系统管理员,协理员,区县审批,数据修正,查询统计,救助标准管理',
		},
		{
			id: 22,
			title: '特定救助对象管理',
			icon: '组织机构',
			level: 2,
			path: '/subsidy_setup',
			p_id: 2,
			order_num: 7,
			role: '特定救助对象管理',
		},
		{
			id: 23,
			title: '供养机构管理',
			icon: '组织机构',
			level: 2,
			path: '/provider_org',
			p_id: 2,
			order_num: 8,
			role: '系统管理员,区县审批,查询统计',
		},
		{
			id: 3,
			title: '家庭档案',
			icon: '家庭档案',
			level: 1,
			path: '',
			p_id: 0,
			order_num: 6,
			role: '系统管理员,协理员,乡镇审核,区县审批,发放,查询统计',
			children: [

			]
		},
		{
			id: 31,
			title: '城市低保家庭档案',
			icon: '城市居民',
			level: 2,
			path: '/110/bla',
			p_id: 3,
			order_num: 6,
			role: '系统管理员,协理员,乡镇审核,区县审批,发放,查询统计',
			children: [

			]
		},
		{
			id: 32,
			title: '农村低保家庭档案',
			icon: '农村居民',
			level: 2,
			path: '/120/bla',
			p_id: 3,
			order_num: 7,
			role: '系统管理员,协理员,乡镇审核,区县审批,发放,查询统计',
			children: [

			]
		},
		{
			id: 33,
			title: '城市特困家庭档案',
			icon: '城市特困',
			level: 2,
			path: '/131/bla',
			p_id: 3,
			order_num: 7,
			role: '系统管理员,协理员,乡镇审核,区县审批,发放,查询统计',
			children: [

			]
		},
		{
			id: 34,
			title: '农村特困家庭档案',
			icon: '农村特困',
			level: 2,
			path: '/132/bla',
			p_id: 3,
			order_num: 7,
			role: '系统管理员,协理员,乡镇审核,区县审批,发放,查询统计',
			children: [

			]
		},
		{
			id: 36,
			title: '临时救助家庭档案',
			icon: '临时救助',
			level: 2,
			path: '/500/bla',
			p_id: 3,
			order_num: 7,
			role: '系统管理员,协理员,乡镇审核,区县审批,发放,查询统计',
			children: [

			]
		},
		{
			id: 35,
			title: '低保边缘家庭档案',
			icon: '低收入救助',
			level: 2,
			path: '/600/bla',
			p_id: 3,
			order_num: 7,
			role: '系统管理员,协理员,乡镇审核,区县审批,发放,查询统计',
			children: [

			]
		},
		{
			id: 37,
			title: '支出型困难人口家庭档案',
			icon: '低收入救助',
			level: 2,
			path: '/650/bla',
			p_id: 3,
			order_num: 7,
			role: '系统管理员,协理员,乡镇审核,区县审批,发放,查询统计',
			children: [

			]
		},
		{
			id: 38,
			title: '脱贫人口家庭档案',
			icon: '低收入救助',
			level: 2,
			path: '/xczx_tprk',
			p_id: 3,
			order_num: 7,
			role: '系统管理员,协理员,乡镇审核,区县审批,发放,查询统计',
			children: [

			]
		},
		{
			id: 39,
			title: '防止返贫监测家庭档案',
			icon: '低收入救助',
			level: 2,
			path: '/xczx',
			p_id: 3,
			order_num: 7,
			role: '系统管理员,协理员,乡镇审核,区县审批,发放,查询统计',
			children: [

			]
		},
		{
			id: 4,
			title: '成员档案',
			icon: '成员档案',
			level: 1,
			path: '',
			p_id: 0,
			order_num: 6,
			role: '系统管理员,协理员,乡镇审核,区县审批,发放,查询统计',
			children: [

			]
		},
		{
			id: 41,
			title: '城市低保成员档案',
			icon: '城市居民',
			level: 2,
			path: '/110/member',
			p_id: 4,
			order_num: 6,
			role: '系统管理员,协理员,乡镇审核,区县审批,发放,查询统计',
			children: [

			]
		},
		{
			id: 42,
			title: '农村低保成员档案',
			icon: '农村居民',
			level: 2,
			path: '/120/member',
			p_id: 4,
			order_num: 7,
			role: '系统管理员,协理员,乡镇审核,区县审批,发放,查询统计',
			children: [

			]
		},
		{
			id: 43,
			title: '城市特困成员档案',
			icon: '城市特困',
			level: 2,
			path: '/131/member',
			p_id: 4,
			order_num: 7,
			role: '系统管理员,协理员,乡镇审核,区县审批,发放,查询统计',
			children: [

			]
		},
		{
			id: 44,
			title: '农村特困成员档案',
			icon: '农村特困',
			level: 2,
			path: '/132/member',
			p_id: 4,
			order_num: 7,
			role: '系统管理员,协理员,乡镇审核,区县审批,发放,查询统计',
			children: [

			]
		},
		{
			id: 46,
			title: '临时救助成员档案',
			icon: '临时救助',
			level: 2,
			path: '/500/member',
			p_id: 4,
			order_num: 7,
			role: '系统管理员,协理员,乡镇审核,区县审批,发放,查询统计',
			children: [

			]
		},
		{
			id: 45,
			title: '低保边缘成员档案',
			icon: '低收入救助',
			level: 2,
			path: '/600/member',
			p_id: 4,
			order_num: 7,
			role: '系统管理员,协理员,乡镇审核,区县审批,发放,查询统计',
			children: [

			]
		},
		{
			id: 47,
			title: '支出型困难人口成员档案',
			icon: '低收入救助',
			level: 2,
			path: '/650/member',
			p_id: 4,
			order_num: 7,
			role: '系统管理员,协理员,乡镇审核,区县审批,发放,查询统计',
			children: [

			]
		},
		{
			id: 48,
			title: '脱贫人口成员档案',
			icon: '低收入救助',
			level: 2,
			path: '/xczx_member_tprk',
			p_id: 4,
			order_num: 7,
			role: '系统管理员,协理员,乡镇审核,区县审批,发放,查询统计',
			children: [

			]
		},
		{
			id: 49,
			title: '防止返贫监测成员档案',
			icon: '低收入救助',
			level: 2,
			path: '/xczx_member',
			p_id: 4,
			order_num: 7,
			role: '系统管理员,协理员,乡镇审核,区县审批,发放,查询统计',
			children: [

			]
		},
		{
			id: 5,
			title: '业务办理',
			icon: '业务办理',
			level: 1,
			path: '',
			p_id: 0,
			order_num: 9,
			role: '系统管理员,协理员,乡镇审核,区县审批,地州,查询统计',
			children: [

			]
		},
		{
			id: 51,
			title: '新申请',
			icon: 'documentation',
			level: 2,
			path: '/new_family',
			p_id: 5,
			role: '系统管理员,协理员',
			order_num: 6
		},
		{
			id: 52,
			title: '家庭经济状况核对',
			icon: 'documentation',
			level: 2,
			path: '/checkList',
			p_id: 5,
			role: '系统管理员,区县审批',
			order_num: 6
		},
		{
			id: 53,
			title: '手机端申请记录',
			icon: '待办',
			level: 2,
			path: '/apply',
			p_id: 5,
			role: '系统管理员,救助申请办理,救助申请查看',
			order_num: 6
		},

		{
			id: 54,
			title: '待提交',
			icon: '待办',
			level: 2,
			path: '/workflow_waitList/01',
			p_id: 5,
			role: '系统管理员,协理员',
			order_num: 6
		},
		{
			id: 55,
			title: '退回修改',
			icon: '待办',
			level: 2,
			path: '/workflow_waitList/06',
			p_id: 5,
			role: '系统管理员,协理员',
			order_num: 6
		},
		{
			id: 56,
			title: '待审核',
			icon: '待办',
			level: 2,
			path: '/workflow_waitList/02',
			p_id: 5,
			role: '系统管理员,乡镇审核',
			order_num: 6
		},
		{
			id: 57,
			title: '待审批',
			icon: '待办',
			level: 2,
			path: '/workflow_waitList/03',
			p_id: 5,
			role: '系统管理员,区县审批',
			order_num: 6
		},
		{
			id: 58,
			title: '已办',
			icon: '已办',
			level: 2,
			path: '/workflow_handledList',
			p_id: 5,
			role: '系统管理员',
			order_num: 6
		},
		{
			id: 59,
			title: '业务统计',
			icon: '已办',
			level: 2,
			path: '/workflow_stats',
			p_id: 5,
			role: '系统管理员,协理员,乡镇审核,区县审批,地州,查询统计',
			order_num: 6
		},
		{
			id: 510,
			title: '监测预警结果处置',
			icon: '组织机构',
			level: 2,
			path: '/warning_indicators_notice_result_list',
			p_id: 5,
			order_num: 1,
			role: '监测预警结果处置,监测预警结果查看',
		},
		{
			id: 590,
			title: '业务查询',
			icon: '已办',
			level: 2,
			path: '/workflow_seek',
			p_id: 5,
			role: '系统管理员,协理员,乡镇审核,区县审批,地州,查询统计',
			order_num: 6
		},
		// {
		// 	id: 591,
		// 	title: '跨区县转移',
		// 	icon: '已办',
		// 	level: 2,
		// 	path: '/batch_stop',
		// 	p_id: 5,
		// 	role: '跨区县转移',
		// 	order_num: 6
		// },
		// {
		// 	id: 59,
		// 	title: '待办',
		// 	icon: '待办',
		// 	level: 2,
		// 	path: '/workflow_waitList',
		// 	p_id: 5,
		// 	role: '系统管理员',
		// 	order_num: 6
		// },
		{
			id: 591,
			title: '全部',
			icon: '办结',
			level: 2,
			path: '/workflow_processingList',
			p_id: 5,
			role: '系统管理员',
			order_num: 6
		},
    {
      id: 592,
      title: '临时救助处理状态统计',
      icon: '待办',
      level: 2,
      path: '/temporary_stats',
      p_id: 5,
      role: 'all',
      order_num: 6
    },
    {
      id: 593,
      title: '本年度临时救助完成统计',
      icon: '待办',
      level: 2,
      path: '/temporary_stats_finish',
      p_id: 5,
      role: 'all',
      order_num: 6
    },
		// {
		// 	id: 56,
		// 	title: '复查',
		// 	icon: '基础信息',
		// 	level: 2,
		// 	path: '/reviewList',
		// 	p_id: 5,
		// 	role: '系统管理员',
		// 	order_num: 6
		// },
		{
			id: 6,
			title: '救助发放',
			icon: '救助发放',
			level: 1,
			path: '',
			p_id: 0,
			role: '系统管理员,发放,临时救助创建,地州查看发放',
			order_num: 9,
			children: [

			]
		},
		{
			id: 61,
			title: '城市低保发放',
			icon: '城市居民',
			level: 2,
			path: '/110/dispense_relief_fund',
			p_id: 6,
			role: '系统管理员,发放,地州查看发放',
			order_num: 6,
			children: [

			]
		},
		{
			id: 62,
			title: '农村低保发放',
			icon: '农村居民',
			level: 2,
			path: '/120/dispense_relief_fund',
			p_id: 6,
			role: '系统管理员,发放,地州查看发放',
			order_num: 7,
			children: [

			]
		},
		{
			id: 63,
			title: '城市特困发放',
			icon: '城市特困',
			level: 2,
			path: '/131/dispense_relief_fund',
			p_id: 6,
			role: '系统管理员,发放,地州查看发放',
			order_num: 7,
			children: [

			]
		},
		{
			id: 64,
			title: '农村特困发放',
			icon: '农村特困',
			level: 2,
			path: '/132/dispense_relief_fund',
			p_id: 6,
			role: '系统管理员,发放,地州查看发放',
			order_num: 7,
			children: [

			]
		},
		{
			id: 7,
			title: '查询统计',
			icon: '查询统计',
			level: 1,
			path: '',
			p_id: 0,
			role: '系统管理员,乡镇审核,区县审批,地州,查询统计',
			order_num: 9,
			children: [

			]
		},
		// {
		// 	id: 70,
		// 	title: '简报',
		// 	icon: '城市居民',
		// 	level: 2,
		// 	path: '/dynamic_statistics',
		// 	p_id: 7,
		// 	role: '简报',
		// 	order_num: 1,
		// 	children: [
    //
		// 	]
		// },
    {
      id: 71,
      title: '城市低保统计表',
      icon: '城市居民',
      level: 2,
      path: '/110-statistical',
      p_id: 7,
      role: '系统管理员,查询统计',
      order_num: 1,
      children: [

      ]
    },
    {
      id: 72,
      title: '农村低保统计表',
      icon: '城市居民',
      level: 2,
      path: '/120-statistical',
      p_id: 7,
      role: '系统管理员,查询统计',
      order_num: 1,
      children: [

      ]
    },
    {
      id: 73,
      title: '城市特困人员情况统计表',
      icon: '城市居民',
      level: 2,
      path: '/131-statistical',
      p_id: 7,
      role: '系统管理员,查询统计',
      order_num: 1,
      children: [

      ]
    },
    {
      id: 74,
      title: '农村特困人员情况统计表',
      icon: '城市居民',
      level: 2,
      path: '/132-statistical',
      p_id: 7,
      role: '系统管理员,查询统计',
      order_num: 1,
      children: [

      ]
    },
		{
			id: 8,
			title: '系统管理',
			icon: '系统管理',
			level: 1,
			path: '',
			p_id: 0,
			role: '系统管理员,用户管理,地州',
			order_num: 9,
			children: [

			]
		},
		{
			id: 81,
			title: '用户管理',
			icon: '用户管理',
			level: 2,
			path: '/sys_user',
			p_id: 8,
			role: '系统管理员,用户管理,地州',
			order_num: 6
		},
		{
			id: 82,
			title: '字典管理',
			icon: '字典管理',
			level: 2,
			path: '/sys_dic',
			p_id: 8,
			role: '开发人员',
			order_num: 7
		},
		// {
		// 	id: 83,
		// 	title: '行政区划管理',
		// 	icon: '字典管理',
		// 	level: 2,
		// 	path: '/sys_addr',
		// 	p_id: 8,
		// 	role: '系统管理员',
		// 	order_num: 7
		// },
		{
			id: 84,
			title: '数据同步管理',
			icon: '字典管理',
			level: 2,
			path: '/data_sync',
			p_id: 8,
			role: '数据同步管理',
			order_num: 7
		},
		{
			id: 84,
			title: '数据初始化',
			icon: '系统管理',
			level: 1,
			path: '/data_initialization',
			p_id: 0,
			order_num: 9,
			role: '数据初始化1',
		},
		{
			id: 9,
			title: '经济状况核对',
			icon: '系统管理',
			level: 1,
			path: '',
			p_id: 0,
			role: '系统管理员,经济状况核对',
			order_num: 9,
			children: [

			]
		},
		{
			id: 91,
			title: '发起核对',
			icon: '字典管理',
			level: 1,
			path: '/verify_list',
			p_id: 9,
			role: '系统管理员,发起核对,家庭经济状况核对角色',
			order_num: 7
		},
		{
			id: 92,
			title: '查看核对报告',
			icon: '字典管理',
			level: 1,
			path: '/verify_report_list',
			p_id: 9,
			role: '系统管理员,查看核对报告,家庭经济状况核对角色',
			order_num: 7
		},
		{
			id: 93,
			title: '核对申请审批',
			icon: '字典管理',
			level: 1,
			path: '/apply_hd_list',
			p_id: 9,
			role: '系统管理员,确认发起核对,家庭经济状况核对角色',
			order_num: 7
		},
		{
			id: 94,
			title: '跨省自动核对批次',
			icon: '字典管理',
			level: 1,
			path: '/cross_provincial_verification',
			p_id: 9,
			role: '跨省核对接收',
			order_num: 7
		},
		{
			id: 95,
			title: '跨省自动核对已接收批次',
			icon: '字典管理',
			level: 1,
			path: '/cross_provincial_verification_receive',
			p_id: 9,
			role: '跨省核对反馈',
			order_num: 7
		},
		{
			id: 96,
			title: '核对统计',
			icon: '字典管理',
			level: 1,
			path: '/verify_cnt',
			p_id: 9,
			role: '系统管理员,核对统计',
			order_num: 7
		},
		// {
		// 	id: 96,
		// 	title: '疑点数据查看',
		// 	icon: '字典管理',
		// 	level: 1,
		// 	path: '/hd_yidian',
		// 	p_id: 9,
		// 	role: '系统管理员',
		// 	order_num: 7
		// },
		// {
		// 	id: 10,
		// 	title: '数据看板',
		// 	icon: '数据看板',
		// 	level: 1,
		// 	path: '/stats',
		// 	p_id: 0,
		// 	role: '数据查看',
		// 	order_num: 10
		// },
		{
			id: 11,
			title: '经办人近亲属管理',
			icon: '组织机构',
			level: 1,
			path: '/near_relatives',
			p_id: 0,
			order_num: 7,
			role: '系统管理员,经办人近亲属管理',
		},
		{
			id: 12,
			title: '不规范数据清查',
			icon: '组织机构',
			level: 1,
			path: '/dirty_data',
			p_id: 0,
			order_num: 8,
			role: '系统管理员,不规范数据清查',
		},
		{
			id: 14,
			title: '监测预警管理',
			icon: '组织机构',
			level: 1,
			path: '',
			p_id: 0,
			order_num: 8,
			role: '系统管理员',
		},
		{
			id: 141,
			title: '监测预警指标管理',
			icon: '组织机构',
			level: 2,
			path: '/warning_indicators_config_list',
			p_id: 14,
			order_num: 1,
			role: '系统管理员',
		},
		{
			id: 142,
			title: '监测预警统计',
			icon: '组织机构',
			level: 2,
			path: '/warning_cnt',
			p_id: 14,
			order_num: 1,
			role: '系统管理员',
		},
		{
			id: 15,
			title: '统一入口',
			icon: '组织机构',
			level: 1,
			path: '/new_page_home',
			p_id: 0,
			order_num: 1,
			role: '开发人员',
		},
    {
      id: 16,
      title: '运维工具',
      icon: '组织机构',
      level: 1,
      path: '/om_tools',
      p_id: 0,
      order_num: 1,
      role: '运维人员',
    },
    {
      id: 17,
      title: '家庭关系图谱',
      icon: '组织机构',
      level: 1,
      path: '/new_page_f_relationships',
      p_id: 0,
      order_num: 1,
      role: 'all',
    },
		// {
		// 	id: 151,
		// 	title: '新首页',
		// 	icon: '组织机构',
		// 	level: 2,
		// 	path: '/new_page_home',
		// 	p_id: 15,
		// 	order_num: 1,
		// 	role: '开发人员',
		// },
		// {
		// 	id: 15,
		// 	title: '数据大屏',
		// 	icon: '组织机构',
		// 	level: 1,
		// 	path: '/data_display',
		// 	p_id: 0,
		// 	order_num: 1,
		// 	role: '系统管理员',
		// },
		// {
		// 	id: 191,
		// 	title: '数据修正',
		// 	icon: '系统管理',
		// 	level: 1,
		// 	path: '/data_initialization2',
		// 	p_id: 0,
		// 	order_num: 9,
		// 	role: '系统管理员,数据修正',
		// }

	]
	let tmp_menu = []
	let tmp_menu_ids = []
	for (let ii = 0; ii < menuAll.length; ii++) {
		for (let i = 0; i < roles.length; i++) {
			if (menuAll[ii]['role']) {
				if (menuAll[ii]['role'].includes(roles[i]) || menuAll[ii]['role'] === 'all') {
					if (tmp_menu_ids.indexOf(menuAll[ii].id)===-1) {
						tmp_menu.push(menuAll[ii])
						tmp_menu_ids.push(menuAll[ii].id)
					}
				}
			}
		}
	}

	return toTree(tmp_menu,'id','p_id',0)
}
function toTree(array, id_key, pid_key, pid) {
  var res = []
  var tmp = null
  var arrayLength = array.length
  for (var i = 0; i < arrayLength; i++) {

    if (array[i][pid_key] === pid) {
      tmp = toTree(array, id_key, pid_key, array[i][id_key])
      if (tmp.length > 0) {
        array[i]['children'] = tmp
      }
      res.push(array[i])
    }
  }
  return res
}
export default rolesToMenu



// WEBPACK FOOTER //
// ./src/utils/rolesToMenu.js